import {useState, useEffect, useRef} from 'react';
import { useStyles } from './styles';
import { Box, Button, TextareaAutosize, Typography, FormControl, Select, MenuItem, InputLabel, FormControlLabel, Checkbox, CircularProgress, Tooltip, ClickAwayListener } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import HelpIcon from '@material-ui/icons/Help';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { decrypt, encrypt } from '../../../helpers/encrypt';
import { checkValidEmail, isAdminCheck, getAppSource, getUserType, checkDigitOnly, renderDefaultMsg } from '../../../helpers';
import { submitRefinanceRequest, getAllStateList, getLendingGoal, getPrivacySecurityContent } from '../../../actions';
import Cookies from 'js-cookie';
import checkCircle from '../../../assets/Checkmarkpaperless.png';

export const CallMeAlert = (props) => {

  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [additionalNote, setAdditionalNote] = useState("");
  const [checkboxState, setCheckboxState] = useState(false);
  const [mobileNo, setMobileNo] = useState(props?.userProfile?.mobileNo ? decrypt(props?.userProfile?.mobileNo) : '');
  const [mobileNoErr, setMobileNoError] = useState("");
  const [errorMessage, setErrorMessage] = useState("")
  const [emailId, setEmailId] = useState(props?.userProfile?.emailID ? decrypt(props?.userProfile?.emailID) : '');
  const [emailError, setEmailError] = useState("");
  const [stateData, setStateData] = useState([]);
  const [nonLendingStates, setNonLendingStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [stateErrorMsg, setStateErrorMsg] = useState('');
  const [loanState, setLoanState] = useState('');
  const [consentPopupOpen, setConsentPopupOpen] = useState(false);
  const [mandatoryFields, setMandatoryFields] = useState(false);
  const [isSubmit, isSubmitStatus] = useState(false);
  const [loaderStatus, setloaderStatus] = useState(false);
  const selectedAccountData = useSelector(state => state.selectedAccountData);
  const loanInfo = useSelector(state => state?.loanInfoReducer);
  const [lendingGoalData, setLendingGoalData] = useState([]);
  const [consentHtml, setConsentHtml] = useState('');
  const [contentHeader, setContentHeader] = useState('Talk to a Loan Officer');
  const [contentSubHeader, setContentSubHeader] = useState("Fill out the short form below and we'll have a licensed Loan Officer reach out within 1 business day.");
  const [successContentValue, setSuccessContentValue] = useState('A licensed Loan Officer will reach out within 1 business day to discuss your lending options.');
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [openToolTip, setOpenToolTip] = useState(false);
  const dispatch = useDispatch();
  
  useEffect(() => {
    getState();
    getLendingGoalData();
    getData();
  }, []);

  const getData = async () => {
    const res = await dispatch(getPrivacySecurityContent('PC037'));
    if (res && res.lstPageContentDetails) {
      const lendingContent = res.lstPageContentDetails.find((item) => String(item?.contentKey || '').toUpperCase() === 'LENDINGCONTENT');
      const consent = res.lstPageContentDetails.find((item) => String(item?.contentKey || '').toUpperCase() === 'CONSENT');
      setContentHeader(lendingContent?.contentHeader || 'Talk to a Loan Officer');
      setContentSubHeader(lendingContent?.contentSubHeader || "Fill out the short form below and we'll have a licensed Loan Officer reach out within 1 business day.");
      setSuccessContentValue(lendingContent?.contentValue || 'A licensed Loan Officer will reach out within 1 business day to discuss your lending options.');
      setConsentHtml(consent?.contentValue || '');
    } else {
      setContentHeader('Talk to a Loan Officer');
      setContentSubHeader("Fill out the short form below and we'll have a licensed Loan Officer reach out within 1 business day.");
      setSuccessContentValue('A licensed Loan Officer will reach out within 1 business day to discuss your lending options.');
      setConsentHtml('');
    }
  }

  const checkboxChangeHandler = (event) => {
    setCheckboxState(event.target.checked)
  }

  const openConsentPopup = () => {
    setConsentPopupOpen(true);
  }

  const closeConsentPopup = () => {
    setConsentPopupOpen(false);
  }

  const handleTooltipClose = () => {
    setOpenToolTip(false);
  };

  const handleTooltipOpen = () => {
    setOpenToolTip(true);
  };

   const addDescription = () => {
    setDescriptionStatus(!addDescriptionStatus)
  }
  
  const handleMobileNo = (event) => {
    if (checkDigitOnly(event.target.value)) {
     setMobileNo(event.target.value)
    } 
  }

  const handleCommment = (event) => {
    setAdditionalNote(event.target.value)
  }

  const handleCancel= (status) => {
    props.closeCallMePopup(status)
  }

  const handleFormStateChange = (event) => {
    setSelectedState(event.target.value);
  }
 
  const handleConfirm = async () => {
    // Cancel any pending debounced email validation and run it synchronously now
    if (emailValidationTimer.current) {
      clearTimeout(emailValidationTimer.current);
      emailValidationTimer.current = null;
    }
    const isPhoneValid = validateMobileNo(mobileNo);
    const isEmailValid = validateEmail(emailId);

    if (!isPhoneValid || !isEmailValid || checkValidations()) {
      setMandatoryFields(true)
    } else {
      setloaderStatus(true)
      setMandatoryFields(false)
      const data = {
        "emailId": emailId ? encrypt(emailId) : null,
        "phoneNo": encrypt(mobileNo),
        "propertyState": selectedAccountData.propertyState,
        "newLoanState": (loanState?.toLowerCase() == "buy a new home (purchase loan)") ? selectedState?.stateCode : null,
        "requestSource": "PostLogin",
        "callbackReason": loanState,
        "isMilitaryVeteran": null,
        "isConsent": checkboxState,
        "description": additionalNote,
        "accountNumber": Cookies.get("selectedAccount"),
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": "",
      };

      const response = await submitRefinanceRequest(data);
      if (response) {
        setloaderStatus(false)
        if (response?.responseData?.lstResponseStatus && (response?.responseData?.lstResponseStatus[0]?.statusCode == 0)) {
          isSubmitStatus(true)
          setErrorMessage("")
        } else {
          setErrorMessage(renderDefaultMsg('400'))
        }
      } else {
        setloaderStatus(false)
        setErrorMessage(renderDefaultMsg('400'))
      }
    }
  }
  
  const calculateCommentLenth = () => {
    const length = additionalNote?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }

  const validateMobileNo = (value) => {
    if (!value) {
      setMobileNoError('');
      return true;
    }
    if (checkDigitOnly(value) && value.length === 10) {
      setMobileNoError('');
      return true;
    }
    setMobileNoError('Please enter valid phone number.');
    return false;
  }

  const validateEmail = (value) => {
    const emailValue = value?.trim();
    if (!emailValue) {
      setEmailError('');
      return true;
    }
    if (checkValidEmail(emailValue)) {
      setEmailError('');
      return true;
    } else {
      setEmailError('Please enter valid email address.')
      return false;
    }
  }

  const getState = async (e) => { 
    const response = await getAllStateList();
    if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 0) {
      setStateErrorMsg('');
      const nonLendingStateList = (response.stateList || [])
        .filter((item) => item?.isLending === false || item?.isLending === 'false')
        .map((item) => String(item?.stateName || '').trim())
        .filter((name) => name !== '');
      const lendingStates = (response.stateList || [])
        .filter((item) => item?.isLending === true || item?.isLending === 'true')
        .map((item) => ({
          ...item,
          stateName: String(item?.stateName || '').trim()
        }));
      setNonLendingStates(nonLendingStateList);
      setStateData(lendingStates);
    } else if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 1001) {
      setStateErrorMsg(response.lstResponseStatus[0].statusDesc);
      setNonLendingStates([]);
    } else {
      setStateErrorMsg(renderDefaultMsg('400'));
      setNonLendingStates([]);
    }
  }

  const getLendingGoalData = async () => {
    const response = await getLendingGoal();
    if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 0) {
      const list = response.lendingGoalList || [];
      setLendingGoalData(list);
    } else {
      setLendingGoalData([]);
    }
  }

  const checkValidations = () => {
    if ((mobileNo == undefined) || (mobileNo == "") || (mobileNo?.trim().length === 0) || (mobileNoErr !== '') || (loanState == '') || ((loanState?.toLowerCase() === "buy a new home (purchase loan)") && (selectedState == null)) || !checkboxState) {
      return true
    } else {
      return false
    }
  }

  const handleSaveOnLoansChange = (event) => {
    setLoanState(event.target.value)
  }

  const emailValidationTimer = useRef(null);

  const handleEmailId = event => {
    const value = event.target.value;
    setEmailId(value);
    if (emailValidationTimer.current) {
      clearTimeout(emailValidationTimer.current);
    }
    emailValidationTimer.current = setTimeout(() => {
      const emailValue = value?.trim();
      if (!emailValue) {
        setEmailError('');
        return;
      }
      if (checkValidEmail(emailValue)) {
        setEmailError('');
      } else {
        setEmailError('Invalid email address.');
      }
    }, 400);
  }

  const formatPhone = (num) => {
    const value = String(num || '').replace(/\D/g, '').slice(0, 10);
    if (value.length !== 10) {
      return 'Not Provided';
    }
    return value;
  }

  const formatPhoneForSuccess = (num) => {
    const value = String(num || '').replace(/\D/g, '').slice(0, 10);
    if (value.length !== 10) {
      return 'Not Provided';
    }
    return `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6, 10)}`;
  }

  const handleEditContact = () => {
    setIsEditingContact(true);
  }

  const handleDoneContact = () => {
    const isPhoneValid = validateMobileNo(mobileNo);
    const isEmailValid = validateEmail(emailId);
    if (isPhoneValid && isEmailValid) {
      setIsEditingContact(false);
    }
  }

  const formatStateNames = (states) => {
    if (!states || states.length === 0) {
      return '';
    }
    if (states.length === 1) {
      return states[0];
    }
    if (states.length === 2) {
      return `${states[0]} and ${states[1]}`;
    }
    return `${states.slice(0, -1).join(', ')} and ${states[states.length - 1]}`;
  }

  const disabledStatesTooltip = nonLendingStates.length
    ? `${formatStateNames(nonLendingStates)} ${nonLendingStates.length === 1 ? 'is' : 'are'} not available at this time.`
    : '';
  const servicingCenterRoute = loanInfo?.isSupportTicket ? '/SupportTicket' : '/HelpLanding';
  const handleServicingCenterClick = () => {
    history.push(servicingCenterRoute);
  }

  return (
    <>
      <Dialog
        open={!isSubmit}
        fullScreen={fullScreen}
        fullWidth
        maxWidth={false} 
        PaperProps={{
          classes: { root: classes.dialogStyle },
          style: { maxWidth: 'none', width: 600 } 
        }}
      >
      <Box className={classes.root}>
        <IconButton  className={classes.closeIcon} onClick={() => handleCancel(false)}>
          <CancelIcon />
        </IconButton>
         {!isSubmit && <Box className={classes.serviceStrip}>
          <Typography className={classes.serviceStripText}>
            Looking for help with a loan we service?{' '}
            <span role="button" tabIndex={0} className={classes.serviceStripLink} onClick={handleServicingCenterClick}>Go to Servicing Center</span>
          </Typography>
         </Box>}
        { !isSubmit &&
          <Box className={classes.cardBody}>
            <Typography className={classes.heroTitle}>{contentHeader}</Typography>
            <Typography className={classes.heroSubTitle}>
              {contentSubHeader}
            </Typography>

            <Box className={classes.contactCard}>
              <Box>
                <Typography className={classes.contactHeading}>WE'LL CONTACT YOU AT:</Typography>
                {!isEditingContact ? (
                  <Box className={classes.contactValuesRow}>
                    <Box className={classes.contactItem}>
                      <PhoneIcon className={classes.contactInfoIcon} />
                      <span style={{ color: 'red', fontWeight: 700, marginRight: 2 }}>*</span>
                      <Typography className={classes.contactValue}>{formatPhone(mobileNo)}</Typography>
                    </Box>
                    <Box className={classes.contactItem}>
                      <EmailIcon className={classes.contactInfoIcon} />
                      <Typography className={classes.contactValue}>{emailId?.trim() ? emailId : 'Not Provided'}</Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box className={classes.contactEditGrid}>
                    <Box className={classes.contactFieldGroup}>
                      <Typography className={classes.contactFieldLabel}>Phone <span style={{ color: 'red' }}>*</span></Typography>
                      <input
                        type="text"
                        maxLength={10}
                        value={mobileNo}
                        onChange={handleMobileNo}
                        className={classes.contactInlineInput}
                      />
                    </Box>
                    <Box className={classes.contactFieldGroup}>
                      <Typography className={classes.contactFieldLabel}>Email (optional)</Typography>
                      <input
                        type="text"
                        value={emailId}
                        onChange={handleEmailId}
                        className={classes.contactInlineInput}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
              {!isEditingContact ? (
                <Typography className={classes.editLink} onClick={handleEditContact}>Edit</Typography>
              ) : (
                <Typography className={classes.editLink} onClick={handleDoneContact}>Done</Typography>
              )}
            </Box>
            {mobileNoErr !== '' && <Typography className={classes.validationError}>{mobileNoErr}</Typography>}
            {emailError !== '' && <Typography className={classes.validationError}>{emailError}</Typography>}

            <Box className={classes.fieldSection}>
              <p className={classes.typography}>What's your goal? <span style={{ color: "red" }}>*</span></p>
              <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%' }}>
              <InputLabel id="borrower-type-select-outlined" className={classes.selectGoalLabel}>Select your goal</InputLabel>
              <Select
                labelId="request-outlined-label"
                id="request-select-outlined"
                color="primary"
                name="request"
                label="Select your goal"
                className={classes.inputStyle}
                fullWidth
                value={loanState}
                onChange={handleSaveOnLoansChange}
              >
                {lendingGoalData.length !== 0 && lendingGoalData.map((item, index) => {
                  const goalValue = String(item?.lendingGoalName || '').replace(/^NULL\s*/i, '').trim();
                  return <MenuItem value={goalValue} key={index}>{goalValue}</MenuItem>
                })}
              </Select>
              </FormControl>
            </Box>

            {(loanState?.toLowerCase() === "buy a new home (purchase loan)") && <Box className={classes.textareaSection}>
              <Box className={classes.propertyLabelRow}>
                <p className={classes.typography}>Property State <span style={{ color: "red" }}>*</span></p>
                {!fullScreen && <Tooltip title={disabledStatesTooltip} placement="top" arrow>
                  <HelpIcon className={classes.propertyTooltipIcon} />
                </Tooltip>}
                {fullScreen && <ClickAwayListener onClickAway={handleTooltipClose}>
                  <Tooltip
                    title={disabledStatesTooltip}
                    arrow
                    placement="top"
                    open={openToolTip}
                  >
                    <HelpIcon className={classes.propertyTooltipIcon} onClick={handleTooltipOpen} />
                  </Tooltip>
                </ClickAwayListener>}
              </Box>
              <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%'}}>
                <InputLabel id="borrower-type-select-outlined">Property State</InputLabel>
                {stateErrorMsg === '' && <Select
                  labelId="borrower-state-outlined-label"
                  id="borrower-state-select-outlined"
                  name="state"
                  color="primary"
                  label="Select a state"
                  className={classes.inputStyle}
                  value={selectedState}
                  onChange={handleFormStateChange}
                  fullWidth >
                  {stateData.length !== 0 && stateData.map((item, index) => {
                    return (
                      <MenuItem value={item} key={(index - 1) + item.stateCode}>{item.stateName}</MenuItem>
                    )
                  })}
                </Select>}
              </FormControl>
            </Box> } 
                  
              <Box className={classes.fieldSection}>
                <Typography className={classes.notesLabel}>Anything else we should know? <span className={classes.optionalText}>(optional)</span></Typography>
                <TextareaAutosize
                  style={{ height: '70px' }}
                  color="primary"
                  variant="outlined"
                  type="text"
                  name="comments"
                  maxLength="500"
                  onChange={(event) => handleCommment(event)}
                  value={additionalNote}
                  placeholder="E.g., best time to call, specific questions, timeline..."
                  className={classes.textArea}
                >
              </TextareaAutosize>
                <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/500</Typography>
              </Box>

              <Box className={classes.consentSection}>
                <FormControlLabel
                  control={<Checkbox
                    checked={checkboxState}
                    onChange={(event) => checkboxChangeHandler(event)}
                    className={classes.checkboxContainer}
                    name="agree"
                  />}
                  label={<Typography className={classes.checkBoxLabel}>By checking this box, you authorize BSI Financial Services to contact you by phone, email, or text regarding loan products. You may opt out at any time. This is not a loan application or commitment to lend. <span style={{ color: "red" }}>*</span></Typography>}
                />
                <Typography className={classes.viewconsent} onClick={openConsentPopup}>View Consent</Typography>
            </Box>
            {mandatoryFields && <Typography className={classes.errorMsg}>Please fill * required fields to submit.</Typography>}
            <Typography className={classes.errorMsg}>{errorMessage !== '' ? errorMessage : ''}</Typography>
            
            <Box className={classes.buttonContainer}>
                <Button type='submit' className={classes.primaryCtaBtn} onClick={() => handleConfirm()} disabled={isAdminCheck()} variant="contained" color="primary" fullWidth>
                          { loaderStatus ? <CircularProgress color='primary' /> : 'Have a Loan Officer Call Me' }
                </Button>
            </Box>
        </Box>}

      </Box>

      <Dialog
        open={consentPopupOpen}
        onClose={closeConsentPopup}
        fullWidth
        maxWidth="sm"
        PaperProps={{ className: classes.consentDialogPaper, style: { maxWidth: 'none', width: 550 } }}
      >
        <Box className={classes.consentDialogHeader}>
          <Typography className={classes.consentDialogTitle}>Consent to Contact</Typography>
          <IconButton className={classes.consentCloseIcon} onClick={closeConsentPopup}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={classes.consentDialogBody}>
          {consentHtml ? (
            <div className={classes.consentHtmlBody} dangerouslySetInnerHTML={{ __html: consentHtml }} />
          ) : (
            <></>
          )}
        </Box>

        <Box className={classes.consentDialogFooter}>
          <Button
            variant="contained"
            color="primary"
            className={classes.consentCloseBtn}
            onClick={closeConsentPopup}
          >
            Close
          </Button>
        </Box>
      </Dialog>
    </Dialog>
    <Dialog
      open={isSubmit}
      fullScreen={fullScreen}
      fullWidth
      maxWidth={false}
      PaperProps={{
        classes: { root: classes.dialogStyle },
        style: { maxWidth: 'none', width: 580 }
      }}
    >
      <Box className={classes.root}>
        <IconButton  className={classes.allSetcloseIcon} onClick={() => handleCancel(false)}>
          <CancelIcon />
        </IconButton>
        <Box className={classes.successBody}>
          <img src={checkCircle} alt="Success" className={classes.successCheckImage} />
          <Typography className={classes.successTitle}>You're All Set!</Typography>
          <Typography className={classes.successSubTitle} dangerouslySetInnerHTML={{ __html: successContentValue }} />
          <Box className={classes.successPhonePill}>
            <Typography className={classes.successPhonePillText}>
              We'll contact you at: <strong>{formatPhoneForSuccess(mobileNo)}{emailId?.trim() ? ` and ${emailId}` : ''}</strong>
            </Typography>
          </Box>
          <Box className={classes.gotItButton}>
            <Button
              variant='contained'
              color='primary'
              className={classes.gotItBtn}
              onClick={() => handleCancel(false)}
            >GOT IT</Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
    </>
  )
}
